import { Area, Line } from '@ant-design/charts';
import { Progress, Radio } from 'antd';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { numberToShortFormat } from '../../../../utils';
import './CampProgressComponent.styles.scss';

const ReachStatsComponent = ({ engagementrate, totalreach, reachData }) => {
  const [data, setData] = useState([]);
  const config = {
    data: data,
    xField: 'date',
    yField: 'value',
    // seriesField: 'name',
    // smooth: true,
    // padding:'auto',
    autoFit: true,
    color: '#8d2fc0',
    areaStyle: () =>{
      return { fill: 'l(270) 0:#e1b7f9  0.5:#8d2fc0 1:#8d2fc0' };
    },
    xAxis: {
      // type: 'time',
      label: {
        type: 'inner',
        formatter: function formatter (v) {
          return moment( moment(v) ).format('Do MMM YY hh:mm');
        },
      },
    },

    yAxis: {
      label: {
        formatter: function formatter (v) {
          return ''.concat(v).replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
            return ''.concat(s, ',');
          });
        },
      },
    },
  };

  useEffect(()=>{
    const _d = [];
    reachData && reachData.map((_r)=>{
      _d.push({
        value: _r.value,
        date: moment(moment(_r.date).toISOString()).format('MM/DD/YYYY hh:mm:ss'),
      });
    });
    const isDescending = false; // set to false for ascending
    _d.sort((a, b) => isDescending ? new Date(b.date).getTime() - new Date(a.date).getTime() : new Date(a.date).getTime() - new Date(b.date).getTime());
    setData(_d);
  }, [reachData]);

  return (
    <div className="common_card mt-3 over_progress_multi p-3">
      <div className="d-flex justify-content-between pb-3">
        <div className="over_progress_multi--title">Engagement Rate: {engagementrate}</div>
        <div className="over_progress_multi--title">Estimated Reach: {numberToShortFormat(totalreach)}</div>
        {/* <div className="over_progress_multi_toggles">
                    <Radio.Group
                        options={[
                            {label:'Influencers',value:'influencers'},
                            {label:'Posts',value:'posts'},
                            {label:'Views',value:'views'},
                        ]}
                        onChange={changeType}
                        value={type}
                        optionType="button"
                        buttonStyle="solid"
                        size="small"
                    />
                </div> */}
      </div>
      <div className="over_progress_multi_bar my-2">
        <Area {...config} />
        {/* <Line {...config} /> */}
        {/* <span className="over_progress_multi_bar--title">{activeType.progessLabel}</span>
                <Progress
                    strokeColor={{
                        '0%': '#e1b7f9',
                        '100%': '#8d2fc0',
                    }}
                    percent={activeType.percent}
                /> */}
      </div>
      {/* <div className="over_progress_multi_stats d-flex flex-wrap justify-content-between">
                {activeType.data.map(({label,value},index)=>(
                    <Fragment key={index+label}>
                        <div className="over_progress_multi_stats--each">{label}: <span>{value}</span></div>
                    </Fragment>
                ))}
            </div> */}
    </div>
  );
};

export default ReachStatsComponent;
